<template>
  <div class="pt-12">
    <media-manager
      ref="mediaManager"
      v-model="selectedId"
      :page.sync="page"
    />
    <!-- Pending modal (upload pending custom dialog modal) -->
    <custom-dialog
      v-model="pendingModalVisible"
      :title="$t(pendingModalTitle)"
      :subtitle="$t(pendingModalSubtitle)"
      show-action
      @confirm="handlePendingModalConfirm"
    />
  </div>
</template>

<script>
import MediaManager from '../components/MediaManager/MediaManager';
import CustomDialog from '../components/Modales/CustomDialog';

export default {
  components: {
    MediaManager,
    CustomDialog,
  },
  data () {
    return {
      selectedId: null,
      page: 1,
      pendingModalVisible: false,
      pendingModalTargetRoute: null,
      pendingModalTitle: '',
      pendingModalSubtitle: '',
    };
  },
  // Navigation guard to prevent the user from accidentally quitting the module
  // while files are uploading or modifications are not saved.
  beforeRouteLeave (to, from, next) {
    if (this.pendingModalVisible === true) {
      return next();
    }

    if (this.$refs.mediaManager.uploading) {
      this.showPendingModal(to, {
        title: 'mediamanager.modales.upload_pending_modal_title',
        subtitle: 'mediamanager.modales.upload_pending_modal_subtitle'
      });
    } else if (this.$refs.mediaManager.editing) {
      this.showPendingModal(to, {
        title: 'dialogs.exit_without_saving_title',
        subtitle: 'dialogs.exit_without_saving_subtitle'
      });
    } else {
      next();
    }
  },
  methods: {
    /**
     * If files are being uploaded, show a warning modal to cancel or confirm the user's action
     *
     * @param {Object} targetRoute - The route that the user is targetting
     * @returns {Void}
     */
    showPendingModal (targetRoute, { title, subtitle } = {}) {
      this.pendingModalTargetRoute = targetRoute;
      this.pendingModalTitle = title;
      this.pendingModalSubtitle = subtitle;
      this.pendingModalVisible = true;
    },
    handlePendingModalConfirm () {
      this.$router.push(this.pendingModalTargetRoute);
    },
  }
};
</script>
